
import {
    setBreadcrumbLinks,
    setCurrentPageTitle,
} from '@/core/helpers/breadcrumb';
import {
    getErrorMsg,
    swalErrNotification,
    swalNotification,
} from '@/core/helpers/utils';
import { useButtonCustom } from '@/core/hooks/use-button-custom';
import { useDateTime } from '@/core/hooks/use-date-time-hook';
import { useLoading } from '@/core/hooks/use-loading';
import { useRouterCustom } from '@/core/hooks/use-router-custom';
import {
    IDinhMucCoDinhNewResponseBase,
    IKeHoachSuaChuaResponseBase,
} from '@/core/interfaces/ApiResponses';
import { KeHoachNamService } from '@/core/services/KeHoachNam.service';
import { defineComponent } from 'vue';
import { DinhMucCoDinhService } from '@/core/services/DinhMucCoDinh.service';
import BaseLink from '@/components/shared/base-link/BaseLink.vue';
import DinhMucCoDinhSection from '@/components/dinh-muc-co-dinh-section/DinhMucCoDinhSection.vue';
import ButtonCustom from '@/components/shared/buttons/ButtonCustom.vue';
import LabelCustom from '@/components/shared/label-custom/LabelCustom.vue';
import PageContentBase from '@/layout/_shared/PageContentBase.vue';
import PageContentSection from '@/layout/_shared/PageContentSection.vue';
import ResponsiveLayout from '@/layout/_shared/ResponsiveLayout.vue';
import Can from '@/components/Can.vue';
import { KE_HOACH_SUA_CHUA } from '@/core/constants/permissions';
import { mapMutations } from 'vuex';

export default defineComponent({
  name: 'chi-tiet-ke-hoach-nam',

  components: {
    BaseLink,
    ButtonCustom,
    Can,
    DinhMucCoDinhSection,
    LabelCustom,
    PageContentBase,
    PageContentSection,
    ResponsiveLayout,
  },

  setup() {
    const { push, id: idKeHoach } = useRouterCustom();
    const { ButtonTypeColors, ButtonsType } = useButtonCustom();
    const { startLoading, endLoading } = useLoading();
    const { moment } = useDateTime();

    return {
      KE_HOACH_SUA_CHUA,
      push,
      idKeHoach,
      startLoading,
      endLoading,
      ButtonTypeColors,
      ButtonsType,
      moment,
    };
  },

  data() {
    return {
      dinhMucCoDinhhDetail: null as IDinhMucCoDinhNewResponseBase | null,
      keHoachDetail: null as IKeHoachSuaChuaResponseBase | null,
    };
  },

  async mounted() {
    setBreadcrumbLinks([
      {
        text: 'Kế hoạch sửa chữa năm',
        routeData: { name: 'danh-sach-ke-hoach-nam' },
      },
      {
        text: 'Chi tiết',
      },
    ]);

    await this.fetchData();

    setCurrentPageTitle(
      this.keHoachDetail?.ten_ke_hoach || 'Chi tiết kế hoạch năm'
    );

    document.title = `${
      this.keHoachDetail?.ten_ke_hoach || 'Chi tiết'
    } - Kế hoạch sửa chữa năm - Đường sắt Hà Nội`;
  },

  methods: {
    ...mapMutations('ConfirmationDialogModule', {
      setDialog: 'setDialog',
      closeDialog: 'closeDialog',
    }),

    onDeleteKeHoachButtonClick() {
      if (!this.keHoachDetail) {
        return;
      }

      this.setDialog({
        message: `Bạn có chắc chắn muốn xoá kế hoạch sửa chữa năm ${this.keHoachDetail.ten_ke_hoach}?`,
        onConfirm: async () => {
          this.closeDialog();
          await this.startLoading();

          try {
            await KeHoachNamService.delete(this.keHoachDetail?.id ?? this.idKeHoach);
            await this.endLoading();
            await swalNotification('Xoá kế hoạch sửa chữa năm thành công');

            this.$router.replace({
              name: 'danh-sach-ke-hoach-nam',
            });
          } catch (e) {
            await this.endLoading();
            await swalErrNotification(e, 'Không thể xoá kế hoạch sửa chữa năm này');
          }
        },
      });
    },

    async fetchData() {
      try {
        this.startLoading();

        const {
          data: { data },
        } = await KeHoachNamService.get(this.idKeHoach);

        this.keHoachDetail = data;

        this.dinhMucCoDinhhDetail =
          await DinhMucCoDinhService.getDinhMucCoDinhByIdCapSuaChuaAndDMTX({
            id_cap_sc: this.keHoachDetail.id_cap_sc,
            id_dm_toa_xe: this.keHoachDetail.id_danh_muc_toa_xe,
            status: 'valid',
          });

        this.endLoading();
      } catch (e) {
        this.endLoading();
        swalNotification(getErrorMsg(e, 'Có lỗi xảy ra'), 'error');
      }
    },
  },
});
